<template>
    <transition name="modal-bounce">
        <div class="modal fade show" v-if="modelValue" style="display: block;" tabindex="-1">
            <div class="modal-dialog">
                 <div class="modal-content bg-light-gray">
                    <div class="modal-header">
                        <h5 class="modal-title">麻醉中藥用事件 ({{ timeLabel }})</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                     <div class="modal-body pb-4">
                        <div class="event-log">
                            <div class="mb-3">
                                <label class="form-label">Drug</label>
                                <selectedDropMenu
                                    :disabled="(viewMode=='view')"
                                    v-model="formData.item_id"
                                    :options="getMedicineList"
                                ></selectedDropMenu>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Dosage (exp.)</label>
                                <input class="form-control" type="number" 
                                    :value="formData.dosage_exp" disabled 
                                />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Dosage (actual)</label>
                                <input class="form-control" type="number" 
                                    v-model.number="formData.dosage_actual" 
                                />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Volume (exp.)</label>
                                <input class="form-control" type="number" 
                                    :value="formData.volume_exp" disabled 
                                />
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Volume (actual)</label>
                                <input class="form-control" type="number" 
                                    v-model.number="formData.volume_actual" />
                            </div>
                             <div class="mb-3">
                                <label class="form-label">Route</label>
                                <select class="form-control"
                                    v-model="formData.router"
                                >
                                    <option v-for="router in routerList"
                                        :value="router.id">{{ router.name }}</option>
                                </select>
                            </div>
                        </div>
                     </div>
                     <div class="modal-footer">
                        <div class="row w-100">
                             <div class="col-4">
                                <button class="btn btn-outline-success w-100" @click="closeModal">略過</button>
                            </div>
                            <div class="col-8">
                                <button class="btn btn-success w-100" @click="saveData">＋添加麻醉用藥</button>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    </transition>
</template>

<script>
import selectedDropMenu from '@/components/selectedDropMenu.vue'
export default {
    name: 'SurgeryMedicineModal',
    components: {
        selectedDropMenu
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        currentTime: {
            type: Number,
            default: 0
        },
        surgicalMedicationList: {
            type: Array,
            default: () => []
        },
        useSurgicalMedicationList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            speciesCategoryId: 0,
            formData: {
                item_id: -1,
                item_name: '',
                dosage_exp: 0,
                dosage_actual: 0,
                volume_exp: 0,
                volume_actual: 0,
                router: 0,
                router_name: ''
            },
            routerList: [],
            medicineList: [],
            medicineDosageList: []
        }
    },
    computed: {
        getRouter(){
            if ( this.formData.item_id == -1 ){
                return 'N/A'
            }
            const medicationItem = this.surgicalMedicationList.find(item=>item.item_id == this.formData.item_id)
            console.log(`medicationItem:`,medicationItem)
            if ( !medicationItem ){
                return 'N/A'
            }
            const router = this.routerList.find(item=>item.id == medicationItem.router)
            return router ? router.name : 'N/A'
        },
        getMedicineList(){
            let priorityItems = []
            let otherItems = []
            const priorityIds = new Set(this.useSurgicalMedicationList.map(i => i.item_id))
            
            //初始化藥劑選擇
            for (let index = 0; index < this.medicineList.length; index++) {
                const medicineItem = this.medicineList[index];
                if (medicineItem.is_enable == 1) {
                    const item = {
                        value: medicineItem.id,
                        name: `${medicineItem.item_name} / 剩餘庫存:${medicineItem.storage_count}`
                    }
                    
                    if (priorityIds.has(medicineItem.id)) {
                        priorityItems.push(item)
                    } else {
                        otherItems.push(item)
                    }
                }
            }
            
            const result = [{value:-1, name:'請選擇藥劑'}, ...priorityItems, ...otherItems]
            this.$debug(`getMedicineList medicineList = `, result)
            
            return result
        },
        timeLabel() {
            const h = Math.floor(this.currentTime / 3600)
            const m = Math.floor((this.currentTime % 3600) / 60)
            const s = this.currentTime % 60
            const mStr = String(m).padStart(2, '0')
            const sStr = String(s).padStart(2, '0')
            
            if (h > 0) {
                 return `${h}:${mStr}:${sStr}`
             }
            return `${mStr}:${sStr}`
        }
    },
    watch: {
        'formData.item_id'(val) {
            this.$debug(`選擇 formData.item_id=${val}`)
             if (val < 1) return
            const useItem = this.useSurgicalMedicationList.find(i => i.item_id === val)
            if (useItem){
                this.formData.item_name = useItem.drug_name
                 this.formData.dosage_exp = useItem.dosage
                 this.formData.dosage_actual = useItem.dosage
                 this.formData.volume_exp = useItem.volume
                 this.formData.volume_actual = useItem.volume
                //  const router = this.routerList.find(i => i.id === useItem.route)
                 this.formData.router = useItem.route
                return
            }
             //先查詢該藥劑是否已在使用清單中
             const item = this.medicineList.find(i => i.id === val)
             console.log('item=',item)
             if (item) {
                 this.formData.item_name = item.item_name
                 this.formData.dosage_exp = 0
                 this.formData.volume_exp = 0
                 this.formData.router = item.router
                 const router = this.routerList.find(i => i.id === this.formData.router)
                //  this.formData.router_name = router ? router.name : 'IV' // Defaulting if missing
             }  

             console.log('formData=',this.formData)
        },
        modelValue(val) {
            if (val) {
                // Reset form
                 this.formData = {
                    item_id: -1,
                    item_name: '',
                    dosage_exp: 0,
                    dosage_actual: 0,
                    volume_exp: 0,
                    volume_actual: 0,
                    router: 0,
                    router_name: ''
                }
            }
        }
    },
    methods: {
        closeModal() {
            this.$emit('update:modelValue', false)
        },
        saveData() {
            const router = this.routerList.find(i => i.id === this.formData.router)

            console.log('router=',this.formData)

            this.$emit('save', {
                type: 'medicine',
                data: { ...{
                    item_id: this.formData.item_id,
                    item_name: this.formData.item_name,
                    dosage_exp: this.formData.dosage_exp,
                    dosage_actual: this.formData.dosage_actual,
                    volume_exp: this.formData.volume_exp,
                    volume_actual: this.formData.volume_actual,
                    router: this.formData.router,
                    router_name: router ? router.name : 'N/A'
                } },
                timeSeconds: this.currentTime,
                timeLabel: this.timeLabel
            })
            this.closeModal()
        }
    },
    async created() {
        //取得途徑列表
        const parametersRes = await this.$api.parameters.getParameterOptions({
            parameter_id:9
        })
        if ( parametersRes.code !== 200 ){
            return
        }
        this.routerList = this.$api.parameters.getSelectOption(9,parametersRes.data,-1)
        //取得藥劑清單
        const medicineRes = await this.$api.inv.getInventoryItemsStoreByKeywordWithPage({
            item_category_id:3,
            page_size:-1
        })
        this.$debug('medicineRes.code=',medicineRes)
        if ( medicineRes.code != 200 ){
            return
        }
        this.medicineList = medicineRes.data.list

        // 取得物種劑量參數
        const settingRes = await this.$api.speciesItem.getItemsSpeciesCategorySetting({
            type:1,
            species_category_id:this.speciesCategoryId
        })
        if ( settingRes.code !== 200 ){
            return
        }
        this.medicineDosageList = settingRes.data

        console.log('this.useSurgicalMedicationList=',this.useSurgicalMedicationList)
    }
}
</script>

<style scoped>
/* Modal Animation */
.modal-bounce-enter-active, .modal-bounce-leave-active {
    transition: opacity 0.3s ease;
}
.modal-bounce-enter-from, .modal-bounce-leave-to {
    opacity: 0;
}

.modal-bounce-enter-active .modal-content {
    animation: slide-down 0.4s ease-out;
}
.modal-bounce-leave-active .modal-content {
    animation: slide-down 0.3s ease-in reverse;
}

@keyframes slide-down {
    0% {
        transform: translateY(-50px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>
